import config from "../../config";
import settings from "./settings";

const CartItem = ({ items, onDecrement, onIncrement, onRemove }) => {
  if (!items.length) return null;

  // Settings'ten değerleri al
  const containerMargin = settings.containerMargin.value + "px";
  const containerPadding = settings.containerPadding.value + "px";
  const itemBackgroundColor = settings.itemBackgroundColor.value;
  const itemBorderColor = settings.itemBorderColor.value;
  const itemBorderWidth = settings.itemBorderWidth.value + "px";
  const itemBorderRadius = settings.itemBorderRadius.value + "px";
  const itemMarginBottom = settings.itemMarginBottom.value + "px";
  const itemPadding = settings.itemPadding.value + "px";
  const titleFontSize = settings.titleFontSize.value + "px";
  const titleFontWeight = settings.titleFontWeight.value;
  const titleColor = settings.titleColor.value;
  const priceFontSize = settings.priceFontSize.value + "px";
  const priceFontWeight = settings.priceFontWeight.value;
  const priceColor = settings.priceColor.value;
  const detailsFontSize = settings.detailsFontSize.value + "px";
  const detailsColor = settings.detailsColor.value;
  const imageWidth = settings.imageWidth.value + "px";
  const imageHeight = settings.imageHeight.value + "px";
  const imageBorderColor = settings.imageBorderColor.value;
  const imageBorderWidth = settings.imageBorderWidth.value + "px";
  const imageBorderRadius = settings.imageBorderRadius.value + "px";
  const imageMarginLeft = settings.imageMarginLeft.value + "px";
  const quantityControlBackgroundColor =
    settings.quantityControlBackgroundColor.value;
  const quantityControlTextColor = settings.quantityControlTextColor.value;
  const quantityControlWidth = settings.quantityControlWidth.value + "px";
  const quantityControlHeight = settings.quantityControlHeight.value + "px";
  const quantityControlBorderRadius =
    settings.quantityControlBorderRadius.value + "px";
  const buttonBackgroundColor = settings.buttonBackgroundColor.value;
  const buttonTextColor = settings.buttonTextColor.value;
  const buttonFontSize = settings.buttonFontSize.value + "px";
  const buttonPadding = settings.buttonPadding.value + "px";
  const separatorColor = settings.separatorColor.value;
  const separatorWidth = settings.separatorWidth.value + "px";
  const showFavoriteButton = settings.showFavoriteButton.value;
  const showRemoveButton = settings.showRemoveButton.value;
  const showVariantInfo = settings.showVariantInfo.value;
  const showQuantityInfo = settings.showQuantityInfo.value;
  const removeButtonText = settings.removeButtonText.value;
  const favoriteButtonText = settings.favoriteButtonText.value;
  const quantityText = settings.quantityText.value;
  const variantText = settings.variantText.value;

  function handleDecrementClick(item) {
    onDecrement(item);
  }

  function handleIncrementClick(item) {
    onIncrement(item);
  }

  function handleRemoveClick(item) {
    onRemove(item);
  }

  return (
    <div
      style={{
        margin: containerMargin,
        padding: containerPadding,
        maxHeight: "calc(100vh - 200px)",
      }}
    >
      {items.map((item, idx) => {
        if (item.quantity <= 0) return null;
        return (
          <div
            key={item.id}
            style={{
              border: `${itemBorderWidth} solid ${itemBorderColor}`,
              borderRadius: itemBorderRadius,
              backgroundColor: itemBackgroundColor,
              overflow: "hidden",
              marginBottom: itemMarginBottom,
            }}
          >
            {/* top */}
            <div style={{ display: "flex", padding: itemPadding }}>
              {/* details */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: titleFontSize,
                      fontWeight: titleFontWeight,
                      lineHeight: "1.2",
                      color: titleColor,
                    }}
                  >
                    {item.variant.name}
                  </h3>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: "4px",
                      marginTop: "4px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: priceFontSize,
                        fontWeight: 500,
                        color: priceColor,
                        textDecorationLine: "line-through",
                        
                      }}
                    >
                      ₺{item.price.toFixed(2)}
                    </span>
                    <span
                      style={{
                        fontSize: priceFontSize,
                        fontWeight: priceFontWeight,
                        color: priceColor,
                      }}
                    >
                      ₺{item.finalPrice.toFixed(2)}
                    </span>
                  </div>
                  {showQuantityInfo && (
                    <p
                      style={{
                        
                        marginBottom: "4px",
                        fontSize: detailsFontSize,
                        color: detailsColor,
                      }}
                    >
                      {quantityText} {item.quantity}
                    </p>
                  )}
                  {showVariantInfo &&
                    item.sku &&
                    item.sku !== "Default Title" && (
                      <p
                        style={{
                          fontSize: detailsFontSize,
                          marginTop: "2px",
                          color: detailsColor,
                        }}
                      >
                        {variantText} {item.sku}
                      </p>
                    )}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: quantityControlBackgroundColor,
                    borderRadius: quantityControlBorderRadius,
                    width: quantityControlWidth,
                    height: quantityControlHeight,
                    marginTop: "8px",
                  }}
                >
                  <button
                    style={{
                      flex: 1,
                      backgroundColor: "transparent",
                      border: "none",
                      color: quantityControlTextColor,
                      fontSize: "17px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      fontWeight:"700"
                    }}
                    onClick={() => handleDecrementClick(item)}
                  >
                    –
                  </button>
                  <span
                    style={{
                      color: quantityControlTextColor,
                 
                      fontSize: "14px",
                      width: "20px",
                      textAlign: "center",
                      fontWeight:"900",
                    }}
                  >
                    {item.quantity}
                  </span>
                  <button
                    style={{
                      flex: 1,
                      backgroundColor: "transparent",
                      border: "none",
                      color: quantityControlTextColor,
                      fontSize: "17px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      fontWeight:700,
                    }}
                    onClick={() => handleIncrementClick(item)}
                  >
                    +
                  </button>
                </div>
              </div>
              {/* image */}
              <div
                style={{
                  width: imageWidth,
                  height: imageHeight,
                  border: `${imageBorderWidth} solid ${imageBorderColor}`,
                  borderRadius: imageBorderRadius,
                  padding: "8px",
                  marginLeft: imageMarginLeft,
                  flexShrink: 0,
                }}
              >
                <img
                  src={`https://cdn.myikas.com/images/${config.MERCHANT_ID}/${item?.variant.mainImageId}/image_540.webp`}
                  alt={item.variant.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: imageBorderRadius,
                  }}
                />
              </div>
            </div>
            {/* bottom */}
            <div
              style={{
                display: "flex",
                borderTop: `${itemBorderWidth} solid ${itemBorderColor}`,
              }}
            >
              {showRemoveButton && (
                <button
                  style={{
                    flex: 1,
                    padding: buttonPadding,
                    backgroundColor: buttonBackgroundColor,
                    color: buttonTextColor,
                    fontSize: buttonFontSize,
                    cursor: "pointer",
                    fontWeight:'700',
                    border: "none",
                  }}
                  onClick={() => handleRemoveClick(item)}
                >
                  {removeButtonText}
                </button>
              )}
              {showRemoveButton && showFavoriteButton && (
                <div
                  style={{
                    width: separatorWidth,
                    backgroundColor: separatorColor,
                  }}
                />
              )}
              {showFavoriteButton && (
                <button
                  style={{
                    flex: 1,
                    padding: buttonPadding,
                    backgroundColor: buttonBackgroundColor,
                    color: buttonTextColor,
                    fontSize: buttonFontSize,
                     fontWeight:'700',
                    cursor: "pointer",
                    border: "none",
                  }}
                >
                  {favoriteButtonText}
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CartItem;
